import React, { Component, ReactNode } from 'react';
import { Button, Tooltip } from 'antd';
import Icon from '@ant-design/icons/lib/components/Icon';
import cx from 'classnames';

import { IUserToRemove } from './IUserToRemove';
import { ReactComponent as SxInfo } from '../../../assets/sightx-icons/svg/sx-circle-info.svg';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/icon-cross.svg';

import styles from './removeSeats.module.scss';
import { AutoEllipsisTooltip } from '../autoEllipsisTooltip';

interface IExternalProps extends IUserToRemove {
  handleSelection: (email: string) => void;
  disabled: boolean;
}

interface ILocalState {
  removingUser: boolean;
}

type Props = IExternalProps;

export class RemoveSeatSelector extends Component<Props, ILocalState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      removingUser: false
    };
    this.toggleConfirmation = this.toggleConfirmation.bind(this);
    this.toggleUserSelection = this.toggleUserSelection.bind(this);
  }

  private toggleConfirmation() {
    const { removingUser } = this.state;
    this.setState({
      removingUser: !removingUser
    });
  }

  private toggleUserSelection() {
    const { handleSelection, id } = this.props;
    this.setState({
      removingUser: false
    });
    handleSelection(id);
  }

  private getTooltipMessage() {
    const { isOwner, isSelf, disabled } = this.props;
    if (isOwner) {
      return 'This user is an account owner and cannot be deactivated.';
    }
    if (isSelf) {
      return 'You cannot deactivate your own account; only another admin or the account owner can deactivate your user.';
    }
    if (disabled) {
      return 'You have already selected enough users';
    }
  }

  private renderConfirmation() {
    const { removingUser } = this.state;
    if (!removingUser) {
      return null;
    }
    return <div className={styles.confirmationContainer}>
      <div className={styles.confirmationText}>
        Are you sure you want to remove this user?
      </div>
      <div className={styles.confirmationActions}>
        <Button className={cx(styles.confirmationButton, styles.ghostButton)} type='ghost' onClick={this.toggleConfirmation}>No</Button>
        <Button className={cx(styles.confirmationButton, styles.redButton)} type='primary' onClick={this.toggleUserSelection}>Yes</Button>
      </div>
    </div>;
  }

  private renderRemoveButton() {
    const { isOwner, isSelf, disabled } = this.props;
    const { removingUser } = this.state;
    const showTooltip = isOwner || isSelf || disabled;
    const forbidRemoval = isOwner || isSelf || disabled || removingUser;
    return <div className={styles.infoContainer}>
      <Button
        className={styles.removeButton}
        type='link'
        disabled={forbidRemoval}
        onClick={this.toggleConfirmation}
      >
        Remove
      </Button>
      {showTooltip && <Tooltip title={this.getTooltipMessage()} >
        <Icon component={SxInfo} />
      </Tooltip>}
    </div>;
  }

  private renderAction() {
    const { toBeRemoved } = this.props;
    if (toBeRemoved) {
      return <Button
        className={styles.deselectButton}
        type='ghost'
        onClick={this.toggleUserSelection}
      >
        To be removed
        <Icon className={styles.closeIcon} component={CrossSVG} />
      </Button>;
    }
    return this.renderRemoveButton();
  }

  render(): ReactNode {
    const { email } = this.props;
    return <div className={styles.tableRow}>
      <div className={styles.listedUser}>
        <div className={styles.email}>
          <AutoEllipsisTooltip
            text={email}
            tooltipText={email}
          />
        </div>
        {this.renderAction()}
      </div>
      {this.renderConfirmation()}
    </div>;
  }
}
